<div *ngIf="showBanner" class="mvt-outage-banner">
  <div class="mvt-outage-banner__inner">
    <button
      type="button"
      class="mvt-outage-banner__close"
      aria-label="Close maintenance notice"
      (click)="closeBanner()"
    >
      <span
        class="icon-holder fa-light fa-times icon--lg ng-star-inserted"
        aria-hidden="true"
      ></span>
    </button>
    <h3 class="mvt-outage-banner__title">{{ params.title || 'Important' }}</h3>
    <div class="mvt-outage-banner__message">
      <p
        *ngIf="params.message; else defaultMessage"
        class="mvt-outage-banner__copy"
      >
        {{ params.message }}
      </p>
      <ng-template #defaultMessage>
        <p class="mvt-outage-banner__copy">
          We’ll be carrying out scheduled maintenance for
          {{ params.brand || '' }} from {{ params.date || '' }}.
        </p>
      </ng-template>
      <p class="mvt-outage-banner__copy">
        {{
          params.contactCentreMessage ||
            'Our Contact Centre will be unable to book ' +
              (params.brand || '') +
              ' repairs during this time.'
        }}
      </p>
      <p *ngIf="params.apologyMessage !== ''" class="mvt-outage-banner__copy">
        {{
          params.apologyMessage ||
            'We’re sorry for any inconvenience this might cause.'
        }}
      </p>
    </div>
  </div>
</div>
